"use client";
import * as React from "react";

export default function Footer() {
  const isHome =
    typeof window !== "undefined" ? window.location.pathname === "/" : false;

  return null;
}
